import { loadScript } from "./helpers/load-script";

let diagLoaded = false;

/**
 * @returns {Promise<boolean>} retourne une promesse qui se résout quand les labels de diagnostic sont chargés
 */
export default function loadDiagnosticLabels() {
    if (diagLoaded) return Promise.resolve(true)

    diagLoaded = true;

    return loadScript('https://dlg.agence-plus.com/diagnostic-label-generator.min.js')
        .then(() => {
            const dlg = new window['DiagnosticLabelGenerator']('https://dlg.agence-plus.com/')
            return dlg.loadWebFonts().then(() => {
                /** @type {NodeListOf<HTMLElement>} */
                const dpe = document.querySelectorAll('#energeticLabel, .dpeLabel')
                /** @type {NodeListOf<HTMLElement>} */
                const ges = document.querySelectorAll('#climaticLabel, .gesLabel')

                dpe.forEach((el) => {
                    const data = getDiagnosticData(el)
                    dlg.noMargin = !!data.noMargin

                    if (data.consumption && parseInt(data.consumption) == -2) {
                        dlg.drawDPENotConcerned(el, data.width, data.height);
                    } else {
                        dlg.drawDPE(
                            el,
                            data.energeticClass,
                            data.consumption,
                            data.emissions,
                            data.width,
                            data.height,
                            false,
                            data.finalConsumption != '0' ? data.finalConsumption : null
                        );
                    }
                })

                ges.forEach((el) => {
                    const data = getDiagnosticData(el);

                    dlg.noMargin = !!data.noMargin;
                    if (!data.energeticClass || !data.energeticClass.trim()) {
                        dlg.drawGESNotConcerned(el, data.width, data.height);
                    } else {
                        dlg.drawGES(el, data.energeticClass, data.emissions, data.width, data.height);
                    }
                })

                return true
            })
        })
}

/**
 * @param {HTMLElement} el 
 * @returns {{
*   noMargin?,
*   energeticClass?,
*   consumption?,
*   emissions?,
*   finalConsumption?,
*   width?,
*   height?,
*   [key: string]: any,
* }}
*/
function getDiagnosticData(el) {
    let diagnosticData = {};
    if (el.dataset.diagnosticData) {
        try {
            diagnosticData = JSON.parse(el.dataset.diagnosticData);
        } catch (e) {
            console.error('Error parsing diagnostic data', e);
        }
    }

    const props = [
        'noMargin',
        'energeticClass',
        'consumption',
        'emissions',
        'finalConsumption',
        'width',
        'height',
    ];

    props.forEach(prop => {
        if (typeof el.dataset[prop] !== 'undefined') {
            if (el.dataset[prop].toLocaleLowerCase() === 'true') diagnosticData[prop] = true;
            else if (el.dataset[prop].toLocaleLowerCase() === 'false') diagnosticData[prop] = false;
            else diagnosticData[prop] = el.dataset[prop];
        }
    });

    return diagnosticData;
}